import { Static, Type } from '@sinclair/typebox';

export const FilterSectionSchema = Type.Union([
  Type.Object({
    type: Type.Literal('range'),
    name: Type.String(),
    excluded: Type.Optional(Type.Boolean()),
    from: Type.Number(),
    to: Type.Number(),
  }),
  Type.Object({
    type: Type.Literal('values'),
    name: Type.String(),
    excluded: Type.Optional(Type.Boolean()),
    values: Type.Array(Type.String()),
  }),
]);

export const FilterValueSchema = Type.Object({
  sections: Type.Array(FilterSectionSchema),
  fulltext: Type.Optional(Type.String()),
});

export const FilterValueSerializableSchema = Type.Composite([
  FilterValueSchema,
  Type.Object({
    formatVersion: Type.Literal(1),
  }),
]);
export type FilterValueSerializable = Static<
  typeof FilterValueSerializableSchema
>;

export interface FilterPreset {
  id: string;
  organizationId: string;
  userId: string;
  category: string;
  value: any;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}
